import styled from 'styled-components'

export default styled.div`

  display: flex;
  align-items: center;
  flex-flow: row wrap;
  justify-content: flex-start;
  max-width: 100vw;
  z-index: 8;
  margin-top: 100px;


  @media (min-width: ${props => props.theme.small}) {
    position: absolute;
    height: 100vh;
    width: 100vw;
    left: 0;
    top: 0;
    z-index: 8;

    align-items: center;
    margin-top: 0;

      padding: 0 10px;

  }

  > * {
    margin-bottom: 0;
    // line-height: 10px;
    text-align: baseline;
    // margin-right: 15px !important;
    vertical-align: bottom;

  }
`



// WEBPACK FOOTER //
// ./src/components/Stockists.js